let authType = [
  'NONE',
  'BASIC',
  'TLS'
]

export default authType
